import request from './request'

/**
 * 流程模板管理 API
 */

// 分页查询流程模板
export function getTemplatePage(params) {
  return request({
    url: '/workflow/templates/page',
    method: 'post',
    data: params
  })
}

// 获取流程模板详情
export function getTemplateDetail(id) {
  return request({
    url: `/workflow/templates/${id}`,
    method: 'get'
  })
}

// 创建流程模板
export function createTemplate(data) {
  return request({
    url: '/workflow/templates',
    method: 'post',
    data
  })
}

// 更新流程模板
export function updateTemplate(data) {
  return request({
    url: '/workflow/templates',
    method: 'put',
    data
  })
}

// 删除流程模板
export function deleteTemplate(data) {
  return request({
    url: '/workflow/templates',
    method: 'delete',
    data
  })
}

// 更新流程模板状态
export function updateTemplateStatus(data) {
  return request({
    url: '/workflow/templates/status',
    method: 'put',
    data
  })
}

// 复制流程模板
export function copyTemplate(id) {
  return request({
    url: `/workflow/templates/${id}/copy`,
    method: 'post'
  })
}

// 导出流程模板（BPMN XML）
export function exportTemplateBpmn(id) {
  return request({
    url: `/workflow/templates/${id}/export/bpmn`,
    method: 'get',
    responseType: 'blob'
  })
}

// 导入流程模板
export function importTemplate(data) {
  return request({
    url: '/workflow/templates/import',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 流程分类 API
 */

// 获取流程分类列表
export function getWorkflowCategories(params) {
  return request({
    url: '/workflow/categories',
    method: 'get',
    params
  })
}

// 创建流程分类
export function createWorkflowCategory(data) {
  return request({
    url: '/workflow/categories',
    method: 'post',
    data
  })
}

// 更新流程分类
export function updateWorkflowCategory(data) {
  return request({
    url: '/workflow/categories',
    method: 'put',
    data
  })
}

// 删除流程分类
export function deleteWorkflowCategory(params) {
  return request({
    url: '/workflow/categories',
    method: 'delete',
    params
  })
}

// 获取流程分类及模板列表（用于发起审批选择）
export function getCategoriesWithTemplates() {
  return request({
    url: '/workflow/categories/with-templates',
    method: 'get'
  })
}

// 获取审批路径（包含审批人）
export function getApprovalPath(templateId, formData) {
  return request({
    url: `/workflow/templates/${templateId}/approval-path`,
    method: 'get',
    params: formData ? { formData: JSON.stringify(formData) } : undefined
  })
}

/**
 * 审批实例 API
 */

// 发起审批
export function startApproval(data) {
  return request({
    url: '/workflow/start',
    method: 'post',
    data
  })
}

/**
 * 待办任务 API
 */

// 获取我的待办任务列表
export function getMyTasks(params) {
  return request({
    url: '/workflow/tasks/my',
    method: 'post',
    data: params
  })
}

/**
 * 审批实例 API
 */

// 获取我发起的审批列表
export function getMyInstances(params) {
  return request({
    url: '/workflow/instances/my',
    method: 'post',
    data: params
  })
}

// 审批操作（通过/驳回）
export function approveTask(data) {
  return request({
    url: '/workflow/approve',
    method: 'post',
    data
  })
}

// 获取流程实例详情
export function getInstanceDetail(instanceId) {
  return request({
    url: `/workflow/instances/${instanceId}/detail`,
    method: 'get'
  })
}
